module.exports = __webpack_public_path__ + "static/img/culture.6e41587.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/culture.png
// module id = bGRB
// module chunks = 0